import { Component, OnInit, Input} from '@angular/core';
import { SiteModel } from '../../../models/site.model';
import { PlantServiceService } from '../../../services/dashboard/solar/plant-service.service';
import * as moment from 'moment';
@Component({
  selector: 'app-site-info',
  templateUrl: './site-info.component.html',
  styleUrls: ['./site-info.component.scss']
})
export class SiteInfoComponent implements OnInit {
  // tslint:disable-next-line:no-input-rename
  @Input('site-id') siteId: string;
  model: SiteModel;
  lastLoginTime: string;
  constructor(private plantService: PlantServiceService) {
    this.model = new SiteModel();
    this.lastLoginTime = moment().format('DD/MM/YYYY'); // Will get from after user logged in
   }

  ngOnInit() {
    if (this.siteId !== undefined) {
      this.plantService.getSiteDetail(this.siteId).subscribe(
        data => {
          Object.assign(this.model, data);
        }
       );
      }
  }

}
